<!--课题引领-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <!-- 搜索条件 -->
            <div class="form-box">
                <div class="filter-group">
                    <div class="filter-item" v-if="this.topicFilter==='0'">
                        <span class="filter-label">课题状态</span>
                        <el-select class="filter-select" clearable @change="pageList()" v-model="queryParams.status" placeholder="请选择">
                            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                       :value="item.value" />
                        </el-select>
                    </div>
                    <div class="filter-item">
                        <span class="filter-label">课题级别</span>
                        <el-select class="filter-select" clearable @change="pageList()" v-model="queryParams.topicLevel" placeholder="请选择">
                            <el-option v-for="item in topicLevelList" :key="item.value" :label="item.name"
                                       :value="item.value" />
                        </el-select>
                    </div>
                    <div class="filter-item">
                        <span class="filter-label">课题方向</span>
                        <el-select class="filter-select" clearable @change="pageList()"  v-model="queryParams.topicClassifyKey" placeholder="请选择">
                            <el-option v-for="item in topicClassifyList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </div>
                </div>
                <div class="search-group">
                    <el-input class="search-input" v-model="queryParams.topicName" placeholder="请输入名称" clearable
                              @keyup.enter="pageList">
                        <template #append>
                            <el-button class="search-btn" @click="pageList">
                                <el-icon><Search /></el-icon>
                            </el-button>
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="right-container">
                <div class="page-info-container">
                    <div class="info-list-container">
                        <div class="course-list-box">
                            <div class="course-item" v-for="item in dataList" :key="item">
                                <el-card :body-style="{ padding: '0px' }" class="course-one" @click="viewInfo(item)">
                                    <div class="course-name">{{item.topicName}}</div>
                                    <div class="course-info">
                                        <div class="course-cover">
                                            <img class="img-100"  :src="item.coverUrl" alt />
                                        </div>
                                        <div class="course-title">
                                            <div class="course-subject" v-if="topicFilter!=='3'">
                                                <div class="status-info-cs" v-if="item.status===0">初始</div>
                                                <div class="status-info-bm" v-if="item.status===1">进行中</div>
                                                <div class="status-info-zq" v-if="item.status===2">课题结束</div>
                                            </div>
                                            <div class="course-subject" v-if="topicFilter==='3'">
                                                <div class="status-info-cs">已发布</div>
                                            </div>
                                            <div class="course-team-user">
                                                <div v-if="item.topicLevel==='1'">课题级别:国家级课题</div>
                                                <div v-if="item.topicLevel==='2'">课题级别:省级课题</div>
                                                <div v-if="item.topicLevel==='3'">课题级别:市级课题</div>
                                                <div v-if="item.topicLevel==='4'">课题级别:区县课题</div>
                                                <div v-if="item.topicLevel==='5'">课题级别:学校课题</div>
                                            </div>
                                            <div class="course-team-user">课题方向:{{item.topicClassifyName}}</div>
                                            <div class="course-team-user">课题负责:{{item.leaderNames}}</div>
                                            <div class="course-team-user">课题单位:{{item.orgNames}}</div>

                                        </div>
                                    </div>
                                </el-card>
                            </div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </div>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[6, 9, 12]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageList" />
                    </div>
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <host-topic-info :info-id="this.infoId" @change-mode="changeModel"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import topicInfo from "@/components/teachResearch/topicInfo.vue";
import hostTopicInfo from "@/components/teachResearch/hostTopicInfo.vue";
import {pageTopicWeb} from  "@/api/admin/topic"

export default {
    name:'pageTopic',
    components:{topicInfo, pageTag, dataEmpty,hostTopicInfo},
    props:{
        courseMode:{
            type: String,
            default:'page'
        },
        filterItem:{
            type: String,
            default:'0'
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
            this.pageList();
        },
        filterItem(newValue,oldValue){
            this.topicFilter = newValue;
            this.pageList()
        },
    },
    mounted() {
        if (this.$store.state.params.jumpParams.infoId){
            this.infoId = this.$store.state.params.jumpParams.infoId;
            this.showMode = "detail"
            this.$emit('change-mode',this.showMode);
        }
        this.getQueryDict();
        this.pageList();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            timestampToTime,
            topicFilter:this.filterItem,
            itemName:'课题引领',
            itemKey:'',
            queryParams: {
                topicName: '',
                topicLevel: '',
                topicClassifyKey: '',
                status: '',
                isRelease:'',
                pageNum: 1,
                pageSize: 6,

            },
            total: 0,
            pageCount:0,
            dataList: [],
            infoId:'',
            statusList: [
                { name: '进行中', value: 1 },
                { name: '已结束', value: 2 },
            ],
            topicLevelList:[
                { name: '国家级课题', value: 1 },
                { name: '省级课题', value: 2 },
                { name: '市级课题', value: 3 },
                { name: '区县课题', value: 4 },
                { name: '学校课题', value: 5 },
            ],
            topicClassifyList:[],
        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'topic_classify' }).then(res => {
                this.topicClassifyList = res.data.data;
            })
        },
        pageList(){
            if (this.topicFilter === '0'){
                this.queryParams.status = ''
                this.queryParams.isRelease = ''
            }
            if (this.topicFilter === '1'){
                this.queryParams.status = '1'
                this.queryParams.isRelease = ''
            }
            if (this.topicFilter === '2'){
                this.queryParams.status = '2'
                this.queryParams.isRelease = '0'
            }
            if (this.topicFilter === '3'){
                this.queryParams.status = ''
                this.queryParams.isRelease = '1'
            }
            pageTopicWeb(this.queryParams).then(res => {
                this.dataList = res.data.data.list;
                this.total = res.data.data.total;
                this.pageCount = res.data.data.totalPage;
                  this.dataList.forEach(e => {
                      var orgTxt = [];
                      e.orgList.forEach(j => {
                          orgTxt.push(j.orgName)
                      })
                      e.orgTxt = orgTxt.join('、')
                  })

            });
        },
        viewInfo(item){
            this.showMode = "detail"
            this.infoId = item.topicId;
            this.$emit('change-mode',this.showMode);
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 2);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    border-radius: 28px;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 182px);
    background-color: #fff;
    border-radius: 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
/* 搜索条件 */
.form-box{
    width: 100%;
    min-height: 70px;
    flex-shrink: 0;
    border-bottom: 2px solid #ff7f2e;
    background-color: #fff;
    padding: 10px 20px;
    box-sizing: border-box;
    border-top-left-radius: 28px;
    border-top-right-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
}
.filter-group{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    flex: 1;
    min-width: 0;
}
.filter-item{
    display: flex;
    align-items: center;
    gap: 6px;
}
.filter-label{
    font-size: 14px;
    color: #333;
    white-space: nowrap;
}
.filter-select{
    width: 140px;
}
.search-group{
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 12px;
    margin-left: auto;
    flex-shrink: 0;
}
.search-input{
    width: 240px;
}
.search-btn{
    background-color: #ff7f2e;
    color: #fff;
}
.search-btn:hover,
.search-btn:focus{
    background-color: #0b4a8f;
    color: #fff;
}
::v-deep .search-input .el-input-group__append{
    background-color: #ff7f2e;
    box-shadow: none;
}
.right-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
}
.page-info-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    background-color: #fff;
    border-bottom-left-radius: 28px;
    border-bottom-right-radius: 28px;
}
.info-list-container{
    width: 100%;
    flex: 1;
    min-height: 0;
    margin: auto;
    overflow-x: hidden;
    overflow-y: auto;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-top: 15px;
    padding-left: 15px;
    align-items: center;
    box-sizing: border-box;
}
.course-item{
    width: 33.3%!important;
    height: auto;
    padding-right: 15px;
    padding-bottom: 15px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 15px;
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 120px;
    padding-top: 10px;
}
.course-cover{
    width: 40%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 60%;
    height: 100%;
}
.course-name{
    width: 100%;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 42px;
}
.course-time{
    width: 100%;
    font-size: 14px;
    color: #333;
    height: 20px;
    line-height: 20px;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    display: flex;
}
.status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #00a173;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-kt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-zq{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-jt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.status-info-js{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #54bcbd;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 5px;
}
.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}
.course-team-user{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    color: #333333;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    flex-shrink: 0;
    padding-top: 15px;
    box-sizing: border-box;
}
.detail-mode{
    width: 100%;
    height: auto;
}
</style>
